<template>
  <div class="edit_item">
    <my_slider
        titleWidth="54"
        :title="title"
        :value.sync="result"
        :min="0"
        :max="100"
        symbol="%"
    ></my_slider>
  </div>
</template>

<script>
import my_slider from '../my_slider'
export default {
  name: 'MyOpacityIndex',
  data() {
    return {
      result: 100 - this.value * 100
    }
  },
  components: {
    my_slider
  },
  props: {
    value: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    }
  },
  watch: {
    result() {
      const opacity = (100 - this.result) / 100
      this.$emit('update:value', opacity)
    },
    value(val) {
      this.result = 100 - val * 100
    }
  }
}
</script>

<style scoped>
.edit_item {
  margin-bottom: 15px;
}
</style>
